export default __webpack_public_path__ + "static/media/colorSplotchSilver.d1f250c2.svg";